/* eslint-disable no-console */
import {DownloadOutlined, ReloadOutlined} from '@ant-design/icons';
import {Flex, Button} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

// import generalized1 from '../../../assets/generalized1.png';
// import generalized2 from '../../../assets/generalized2.png';
// import CarouselComp from '../../../components/Carousel/CarouselComp';
// import CarouselContent from '../../../components/Carousel/utils/CarouselContent';
import Loader from '../../../components/Loader/Loader';
import UpgradeButton from '../../../components/UpgradeButton/UpgradeButton';
import {API_ENDPOINT_JSON} from '../../../config';
import {GenerateReportButtonText} from '../../../constants/Common';
import {reportTypeEnum} from '../../../services/constants/enum';
import {APITypeEnum} from '../../../services/interface/tableAPIType';
import emissionCalculation from '../../../services/modules/DASHBOARD/emissionCalculation';
import downloadReportAPI from '../../../services/modules/ESG/ESGReportDownload';
import country from '../../../services/modules/JSON/country';
import statesJSON from '../../../services/modules/JSON/statesJSON';
import nzmAPI from '../../../services/modules/NZM/NZMAPI';
import Year from '../../../shared/Year';
import useUserStore from '../../../store/userStore/userStore';
import {checkCurrentYearOrBelow} from '../../../utils/commonFunctions';
// import {yearSelect} from '../../../utils/FormUtils/yearSelect';
// import CTABanner from '../components/CTABanner';
import showMessage from '../../../utils/showMessage';
// import {reportDownload} from '../constants/commonConstants';
import {shouldBlockReportAccess} from '../../../utils/SubscriptionHelper';

import EnergyAndUtilities from './utils/EnergyAndUtilities';
import GHGEmission from './utils/GHGEmission';
import LabelAndCharts from './utils/LabelAndCharts';

// const carouselContent = [
//   {
//     content: (
//       <CarouselContent
//         image={generalized2}
//         mainTitle="Lorem Ipsum is simply dummy text"
//         description="Lorem Ipsum is simply dummy text of the printing and typesetting..."
//       />
//     )
//   },
//   {
//     content: (
//       <CarouselContent
//         image={generalized1}
//         mainTitle="Lorem Ipsum is simply dummy text"
//         description="Lorem Ipsum is simply dummy text of the printing and typesetting..."
//       />
//     )
//   },
//   {
//     content: (
//       <CarouselContent
//         image={generalized2}
//         mainTitle="Lorem Ipsum is simply dummy text"
//         description="Lorem Ipsum is simply dummy text of the printing and typesetting..."
//       />
//     )
//   }
// ];

const Generalized: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [generateLink, setGenerateLink] = useState<boolean>();
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  // const firstYear = yearSelect();
  const user = useUserStore.getState().userDetails;
  const [refresing, setRefresing] = useState<boolean>();
  const [refreshPage, setRefreshPage] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    if (selectedYear) {
      Promise.all([
        nzmAPI(
          APITypeEnum.GET_ALL,
          API_ENDPOINT_JSON.NZM.generalize,
          selectedYear
        ),
        country(),
        statesJSON()
      ])
        .then(([res1]) => {
          setData(res1);
        })
        .catch(() => {
          setData([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedYear, refreshPage]);

  const handleGenerateClick = (key: any) => {
    setGenerateLink(true);
    downloadReportAPI(selectedYear, reportTypeEnum.ca, key, user._id)
      .then((response) => {
        const reportLink = response.data.urls;
        const fileName = reportLink.split('/');
        const link = document.createElement('a');
        link.href = reportLink;
        link.target = '_blank';
        link.download = fileName?.[fileName.length - 1]; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showMessage(response.data);
      })
      .catch(() => {})
      .finally(() => {
        setGenerateLink(false);
      });
  };

  const handleRefreshClick = () => {
    setRefresing(true);
    Promise.all([emissionCalculation(selectedYear)])
      .then(() => {
        setRefreshPage(!refreshPage);
      })
      .catch(() => {})
      .finally(() => {
        setRefresing(false);
      });
  };

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  return (
    <>
      {/* <Row gutter={[16, 16]} style={{marginBottom: '20px'}}>
        <Col span={14} lg={14} sm={24} md={24}>
          <Flex
            align="center"
            justify="center"
            vertical={false}
            gap="2rem"
            style={{
              width: '100%',
              flex: '2:1',
              height: '18.75rem'
            }}
          >
            <CTABanner
              mainTitle="Lorem ipsum dolor sit amet."
              desc="Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo autem
          fuga, sed deserunt laboriosam ut quas minima iste aliquid consequuntur
          accusantium minus nobis blanditiis ullam"
              img={generalized1}
            />
          </Flex>
        </Col>
        <Col lg={10} sm={24} md={24}>
          <CarouselComp data={carouselContent} autoplay />
        </Col>
      </Row> */}
      <Flex className="generalizedMainFlex" vertical={true}>
        {selectedYear && (
          <Flex justify="space-between" align="center" style={{width: '100%'}}>
            <Flex gap="1rem" align="center">
              <Year
                setSelectedYear={setSelectedYear}
                isESG
                noPadding
                noBottomMargin
                colSpan={24}
                isDisabled={isLoading || refresing}
              />
              {shouldBlockReportAccess('CA') ? (
                <UpgradeButton title={GenerateReportButtonText()} />
              ) : (
                <Button
                  type="default"
                  icon={<DownloadOutlined />}
                  // style={{marginBottom: '10px'}}
                  // href={reportDownload}
                  // target="_blank"
                  // download
                  disabled={isLoading || refresing}
                  loading={generateLink}
                  onClick={() => {
                    handleGenerateClick('pdf');
                  }}
                >
                  {GenerateReportButtonText(generateLink)}
                </Button>
              )}
            </Flex>
            <Button
              type="default"
              icon={<ReloadOutlined />}
              style={{marginBottom: '10px'}}
              title="Reflecting data from Carbon Accounting"
              loading={refresing}
              onClick={() => {
                handleRefreshClick();
              }}
            ></Button>
          </Flex>
        )}
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <LabelAndCharts title="Carbon Emission">
              <GHGEmission data={data} />
            </LabelAndCharts>
            <LabelAndCharts title="Energy & Utilities">
              <EnergyAndUtilities data={data} />
            </LabelAndCharts>
          </>
        )}
      </Flex>
    </>
  );
};

export default Generalized;
